<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/Scales/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>